import { call, put, takeLatest } from 'redux-saga/effects';
import { templateGenerationSettingsActions } from 'app/pages/TemplateGenerationSettingsComponent/slice';
import {
  fetchTemplateGenerationSettings,
  updateTemplateGenerationSettings,
} from './data/templateGenerationSettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchTemplateGenerationSettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchTemplateGenerationSettings, {
      dealershipId: action.payload.dealershipId,
    });
    yield put(
      templateGenerationSettingsActions.requestTemplateGenerationSettingsSuccess(
        response,
      ),
    );
  } catch (error: any) {
    yield put(
      templateGenerationSettingsActions.requestTemplateGenerationSettingsError(
        error?.message || 'Failed to fetch',
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Template generation settings fetch failed',
      }),
    );
  }
}

function* updateTemplateGenerationSettingsSaga(action: ReturnType<any>) {
  try {
    yield call(updateTemplateGenerationSettings, {
      dealershipId: action.payload.dealershipId,
      settingsId: action.payload.settingsId,
      data: action.payload.data,
    });
    yield put(
      templateGenerationSettingsActions.requestUpdateTemplateGenerationSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Template generation settings updated successfully',
      }),
    );
    yield put(
      templateGenerationSettingsActions.requestTemplateGenerationSettings({
        dealershipId: action.payload.dealershipId,
      }),
    );
  } catch (error: any) {
    yield put(
      templateGenerationSettingsActions.requestUpdateTemplateGenerationSettingsError(
        error?.message || 'Failed to update',
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Template generation settings update failed',
      }),
    );
  }
}

export function* watchTemplateGenerationSettingsSaga() {
  yield takeLatest(
    templateGenerationSettingsActions.requestTemplateGenerationSettings.type,
    fetchTemplateGenerationSettingsSaga,
  );
  yield takeLatest(
    templateGenerationSettingsActions.requestUpdateTemplateGenerationSettings
      .type,
    updateTemplateGenerationSettingsSaga,
  );
}
